<template>
<div id="map"></div>
      

  </template>
  
  <script>
  export default {
    name: 'MapComponent', 
    data() {
        return {
        map: null,
        markers: [],
        polyline: null,
        infoWindow: null,
        prevHoveredMarker: null,
        prevHoveredPosition: null,
        qrcode : this.$route.query.qrcode,
        provinces: [], 
        };
    },
    
    mounted() {
      this.initMap();
      this.loadQrcode();
    },
    methods: {

        

        initMap() {
            const mapOptions = {
                center: { lat: -2.5489, lng: 118.0149 },
                zoom: 5,
            };

            this.map = new google.maps.Map(document.getElementById("map"), mapOptions);
            this.infoWindow = new google.maps.InfoWindow();


            const bounds = new google.maps.LatLngBounds();

            this.provinces.forEach((city, index) => {
                const marker = new google.maps.Marker({
                position: { lat: city.lat, lng: city.lng },
                map: this.map,
                title: city.nama_provinsi,
                icon: {
                    url: city.status === 'genuine' ? require('@/assets/maps_green_marker.png') : require('@/assets/maps_green_marker.png'),

                    scaledSize: new google.maps.Size(25, 30)
                }
                });

                this.markers.push(marker);
                bounds.extend(marker.getPosition());

                marker.addListener("mouseover", () => {
                const targetMarker = marker;
                this.map.setZoom(8, { animate: true });
                this.map.setCenter(targetMarker.getPosition());

                let status = 'success';
                let statusText = 'Deteksi Asli';
                if (city.status === 'fake') {
                    status = 'danger';
                    statusText = 'Dicurigai palsu';
                }

                let content = '<table style="width:190px">';
                content += '<tr class="p-2"><td class="fw-bold">' + city.name + '</td><td rowspan="2" style="color:#AFAFAF">' + city.distance + ' KM</td></tr>';
                content += '<tr class="p-2"><td class="my-auto text-' + status + '">' + statusText + '</td></tr>';
                content += '</table>';

                this.infoWindow.setContent(content);
                this.infoWindow.open(this.map, targetMarker);

                if (this.polyline) {
                    this.polyline.setMap(null);
                }
                });

                marker.addListener("mouseout", () => {
                const targetMarker = marker;
                this.map.setZoom(5, { animate: true });
                this.map.setCenter(targetMarker.getPosition());
                this.infoWindow.close();
                });
            });

            this.map.fitBounds(bounds);

            const listItems = document.querySelectorAll(".mapsClick");


            listItems.forEach((item, index) => {
             item.addEventListener("mouseover", () => {
                    const targetMarker = this.markers[index];
                    // const targetPosition = targetMarker.getPosition();
                    // const prevMarkerPosition = index > 0 ? this.markers[index - 1].getPosition() : this.markers[0].getPosition();

                    const bounds = new google.maps.LatLngBounds();

                    this.markers.forEach(marker => {
                        marker.setVisible(false);
                    });

                    for (let i = 0; i <= index; i++) {
                        this.markers[i].setVisible(true);
                        bounds.extend(this.markers[i].getPosition());
                    }

                    this.map.fitBounds(bounds);

                    let status = 'success';
                    let statusText = 'Deteksi Asli';
                    if (this.provinces[index]['status'] === 'fake') {
                        status = 'danger';
                        statusText = 'Dicurigai palsu';
                    }

                    let content = '<table style="width:190px">';
                    content += '<tr class="p-2"><td class="fw-bold">' + this.provinces[index]['name'] + '</td><td rowspan="2" style="color:#AFAFAF">' + this.provinces[index]['distance'] + ' KM</td></tr>';
                    content += '<tr class="p-2"><td class="my-auto text-' + status + '">' + statusText + '</td></tr>';
                    content += '</table>';

                    this.infoWindow.setContent(content);
                    this.infoWindow.open(this.map, targetMarker);

                    google.maps.event.addListener(this.map, 'click', () => {
                        if (this.infoWindow != null) {
                            this.infoWindow.close();
                        }
                    });

                    if (this.polyline) {
                        this.polyline.setMap(null);
                    }

                    const polylineCoordinates = this.markers.slice(0, this.markers.indexOf(targetMarker) + 1).map(m => {
                        return { lat: m.position.lat(), lng: m.position.lng() };
                    });

                    this.polyline = new google.maps.Polyline({
                        path: polylineCoordinates,
                        geodesic: true,
                        strokeColor: "#695BFC",
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                        map: this.map,
                    });
                });
            });

            // listItems.forEach((item, index) => {
            //     item.addEventListener("mouseover", () => {
            //     const targetMarker = this.markers[index];
            //     const targetPosition = targetMarker.getPosition();
            //     const prevMarkerPosition = index > 0 ? this.markers[index - 1].getPosition() : this.markers[0].getPosition();

            //     const bounds = new google.maps.LatLngBounds();

            //     this.markers.forEach(marker => {
            //         marker.setVisible(false);
            //     });

            //     for (let i = 0; i <= index; i++) {
            //         this.markers[i].setVisible(true);
            //         bounds.extend(this.markers[i].getPosition());
            //     }

            //     this.map.fitBounds(bounds);

            //     let status = 'success';
            //     let statusText = 'Deteksi Asli';
            //     if (provinces[index]['status'] === 'fake') {
            //         status = 'danger';
            //         statusText = 'Dicurigai palsu';
            //     }

            //     let content = '<table style="width:190px">';
            //     content += '<tr class="p-2"><td class="fw-bold">' + provinces[index]['name'] + '</td><td rowspan="2" style="color:#AFAFAF">' + provinces[index]['distance'] + ' KM</td></tr>';
            //     content += '<tr class="p-2"><td class="my-auto text-' + status + '">' + statusText + '</td></tr>';
            //     content += '</table>';

            //     this.infoWindow.setContent(content);
            //     this.infoWindow.open(this.map, targetMarker);

            //     google.maps.event.addListener(this.map, 'click', () => {
            //         if (this.infoWindow != null) {
            //         this.infoWindow.close();
            //         }
            //     });

            //     if (this.polyline) {
            //         this.polyline.setMap(null);
            //     }

            //     const polylineCoordinates = this.markers.slice(0, this.markers.indexOf(targetMarker) + 1).map(m => {
            //         return { lat: m.position.lat(), lng: m.position.lng() };
            //     });

            //     this.polyline = new google.maps.Polyline({
            //         path: polylineCoordinates,
            //         geodesic: true,
            //         strokeColor: "#695BFC",
            //         strokeOpacity: 1.0,
            //         strokeWeight: 4,
            //         map: this.map,
            //     });
            //     });
            // });



            },



            async loadQrcode () {
            
                try {
                    let response = await this.$http.get('/dashboard/qr-journey?qrcode=' + this.qrcode)

                    this.journeyData = response.data.data;

                    let firstData = this.journeyData[0];
                    // console.log(firstData);


                    this.provinces = this.journeyData.map(item => ({
                        name: item.nama_provinsi,
                        lat: item.lat,
                        lng: item.lng,
                        status: item.status,
                        distance: item.distance
                    }));


                

                    this.initMap();


                
                }
                catch(err) {
                    console.log(err)
                }
           }


  },
};

</script>

